import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="text-center">
        <p className="text-5xl font-bold text-gray-600">404</p>
        <h1 className="mt-4 text-xl font-semibold text-white">Page Not Found</h1>
        <p className="mt-2 text-gray-400 text-sm">
          The page you are looking for does not exist.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block text-sm text-indigo-400 hover:text-indigo-300 transition-colors"
        >
          Return to dashboard
        </Link>
      </div>
    </div>
  );
}
